import { useLocation, useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { useTranslation } from 'react-i18next';

/** Global "go back" arrow rendered top-left of every page (in the App layout
 *  header). Navigates one entry back in history — i.e. wherever the user came
 *  from. Hidden on the first in-app entry (nothing to go back to), so deep
 *  links / fresh loads don't show a dead button that would leave the app. */
export function BackButton() {
  const navigate = useNavigate();
  const { t } = useTranslation();
  // react-router stores a monotonically increasing `idx` on the history state.
  // 0 = first entry in this browsing session → no in-app history behind us.
  // Reading it via useLocation() keeps it fresh on every navigation.
  useLocation();
  const idx = (window.history.state as { idx?: number } | null)?.idx ?? 0;
  if (idx <= 0) return null;

  return (
    <button
      type="button"
      onClick={() => navigate(-1)}
      aria-label={t('action.back')}
      title={t('action.back')}
      className="inline-flex items-center justify-center rounded p-1.5 text-muted-foreground hover:text-foreground hover:bg-muted"
    >
      <ArrowLeft className="h-5 w-5" />
    </button>
  );
}
